import useGlobalContext from "@src/globalContext/hooks/useGlobalContext";

const useUserIsCig = () => {
  const { cigProfile } = useGlobalContext();

  return cigProfile != null;
};

export default useUserIsCig;
